module.exports = __webpack_public_path__ + "static/20230619_187-da8362bc173e39e346c366c56896ce7a.jpg";